import Head from 'next/head';
import { getSchema } from '../const/product-schema';
import { getFaqSchema } from '../const/faq-schema';
import { getBreadcrumbSchema } from '../const/breadcrumb-schema';
import { getContactSchema } from '../const/contact-schema';

const SEO = ({ title, description, image, url, keywords, page }) => {
  const productSchema = getSchema({ url });
  const faqSchema = page === 'faq' ? getFaqSchema : null;
  const breadcrumbSchema = getBreadcrumbSchema({ url });
  const contactSchema = getContactSchema({ url });
  return (
    <Head>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name='title' content={title} />
      <meta name='description' content={description} />
      <link rel='canonical' href={url} />

      {/* Open Graph / Facebook */}
      <meta property='og:type' content='website' />
      <meta property='og:url' content={url} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={image} />

      {/* Twitter */}
      <meta property='twitter:card' content='summary_large_image' />
      <meta property='twitter:url' content={url} />
      <meta property='twitter:title' content={title} />
      <meta property='twitter:description' content={description} />
      <meta property='twitter:image' content={image} />

      <link
        rel='alternate'
        href={`https://inspektlabs.com/${page}`}
      />
      <link
        rel='alternate'
        href={`https://pt.inspektlabs.com/${page}`}
      />
      <link
        rel='alternate'
        href={`https://es.inspektlabs.com/${page}`}
      />
      {productSchema && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchema) }}
        />
      )}
      {faqSchema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{  __html: JSON.stringify(faqSchema)  }}
        />
      )}
      {breadcrumbSchema && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />
      )}
      {contactSchema && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(contactSchema) }}
        />
      )}
    </Head>
  );
};

export default SEO;
